import type { TranslationKey } from "./i18n";

export type NavIcon =
  | "dashboard"
  | "sessions"
  | "apiKeys"
  | "properties"
  | "porteria"
  | "crmDashboard"
  | "companies"
  | "contacts"
  | "deals"
  | "pipelines"
  | "supportDashboard"
  | "tickets"
  | "categories"
  | "sla"
  | "billingDashboard"
  | "quotes"
  | "invoices"
  | "payments"
  | "accounts"
  | "products"
  | "taxes";
export type NavSection = "main" | "modules" | "crm" | "support" | "billing";

export interface NavItem {
  to: string;
  labelKey: TranslationKey;
  icon: NavIcon;
  section: NavSection;
  end?: boolean;
  permission?: string;
}

export const NAV_ITEMS: NavItem[] = [
  { to: "/", labelKey: "nav.dashboard", icon: "dashboard", section: "main", end: true },
  { to: "/sessions", labelKey: "nav.sessions", icon: "sessions", section: "main" },
  {
    to: "/api-keys",
    labelKey: "nav.apiKeys",
    icon: "apiKeys",
    section: "main",
    permission: "core.api_key.read",
  },
  {
    to: "/crm",
    labelKey: "nav.crmDashboard",
    icon: "crmDashboard",
    section: "crm",
    end: true,
    permission: "crm.deal.read",
  },
  {
    to: "/crm/companies",
    labelKey: "nav.crmCompanies",
    icon: "companies",
    section: "crm",
    permission: "crm.company.read",
  },
  {
    to: "/crm/contacts",
    labelKey: "nav.crmContacts",
    icon: "contacts",
    section: "crm",
    permission: "crm.contact.read",
  },
  {
    to: "/crm/deals",
    labelKey: "nav.crmDeals",
    icon: "deals",
    section: "crm",
    permission: "crm.deal.read",
  },
  {
    to: "/crm/settings/pipelines",
    labelKey: "nav.crmPipelines",
    icon: "pipelines",
    section: "crm",
    permission: "crm.pipeline.read",
  },
  {
    to: "/support",
    labelKey: "nav.supportDashboard",
    icon: "supportDashboard",
    section: "support",
    end: true,
    permission: "support.ticket.read",
  },
  {
    to: "/support/tickets",
    labelKey: "nav.supportTickets",
    icon: "tickets",
    section: "support",
    permission: "support.ticket.read",
  },
  {
    to: "/support/categories",
    labelKey: "nav.supportCategories",
    icon: "categories",
    section: "support",
    permission: "support.category.manage",
  },
  {
    to: "/support/sla",
    labelKey: "nav.supportSla",
    icon: "sla",
    section: "support",
    permission: "support.sla.manage",
  },
  {
    to: "/billing",
    labelKey: "nav.billingDashboard",
    icon: "billingDashboard",
    section: "billing",
    end: true,
    permission: "billing.invoice.read",
  },
  {
    to: "/billing/quotes",
    labelKey: "nav.billingQuotes",
    icon: "quotes",
    section: "billing",
    permission: "billing.quote.read",
  },
  {
    to: "/billing/invoices",
    labelKey: "nav.billingInvoices",
    icon: "invoices",
    section: "billing",
    permission: "billing.invoice.read",
  },
  {
    to: "/billing/payments",
    labelKey: "nav.billingPayments",
    icon: "payments",
    section: "billing",
    permission: "billing.payment.record",
  },
  {
    to: "/billing/accounts",
    labelKey: "nav.billingAccounts",
    icon: "accounts",
    section: "billing",
    permission: "billing.account.read",
  },
  {
    to: "/billing/catalog/products",
    labelKey: "nav.billingProducts",
    icon: "products",
    section: "billing",
    permission: "billing.product.read",
  },
  {
    to: "/billing/settings",
    labelKey: "nav.billingSettings",
    icon: "taxes",
    section: "billing",
    permission: "billing.settings.manage",
  },
  { to: "/properties", labelKey: "nav.properties", icon: "properties", section: "modules" },
  { to: "/porteria", labelKey: "nav.porteria", icon: "porteria", section: "modules" },
];

export function visibleNav(permissions: string[]): NavItem[] {
  return NAV_ITEMS.filter(
    (item) => item.permission === undefined || permissions.includes(item.permission),
  );
}
